import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function Subjectmatterexpert() {
  return (
    <>
      <div>
        <TableList Role="Subject-Matter-Expert" />
      </div>
    </>
  );
}
